import { builder } from '@builder.io/react';

import Header from 'react-scale/components/elements/header';
import SimpleHero from 'react-scale/components/sections/hero/simple-centered';
import ResourcesList from 'react-scale/components/pages/resources/ResourcesList';
import Footer from 'react-scale/components/elements/footer';

import handleError from 'react-scale/lib/handle-error';
import { EventCard, BlogCard } from 'react-scale/components/pages/resources/ResourcesList/box';

export async function getStaticProps() {
  const props = {};

  const events = await builder.getAll('event-model', {
    options: { noTargeting: true },
    omit: 'data.blocks',
    limit: 100
  });

  const builderBlogs = await builder.getAll('blog-model', {
    options: { noTargeting: true },
    omit: 'data.blocks',
    limit: 100
  });

  const builderOpenDatasets = await builder.getAll('open-dataset', {
    options: { noTargeting: true },
    omit: 'data.blocks',
    limit: 100
  });

  const builderInterviews = await builder.getAll('interview', {
    options: { noTargeting: true },
    omit: 'data.blocks',
    limit: 100
  });

  const builderCustomers = await builder.getAll('customers', {
    options: { noTargeting: true },
    omit: 'data.blocks'
  });

  const builderResourcesDownloadModels = await builder.getAll('resources-download-model', {
    options: { noTargeting: true },
    omit: 'data.blocks',
    limit: 100
  });

  try {
    // @ts-ignore
    props.events = events.map(event => event.data);
    // @ts-ignore
    props.blogs = builderBlogs?.map(blog => blog.data);
    // @ts-ignore
    props.resources = builderResourcesDownloadModels?.map(resource => resource.data);
    // @ts-ignore
    props.interviews = builderInterviews.map(interview => interview.data);
    // @ts-ignore
    props.customers = builderCustomers.map(customer => customer.data);
    // @ts-ignore
    props.datasets = builderOpenDatasets?.map(dataset => dataset.data);
  } catch (error) {
    handleError(error);
  }

  return { props, revalidate: 1 };
}

const Resources = ({ blogs, events, customers, resources, interviews, datasets }) => (
  <div className="text-white bg-black">
    <Header
      title="Resources | AI and ML Resources & Documentation | Scale AI"
      description="Explore our resource center for all things AI and Machine Learning. Find the latest open-source datasets, blog posts, to events and more."
      canonical="https://scale.com/resources"
      theme={undefined}
      background={undefined}
      border={undefined}
      borderColor={undefined}
      videoOverlay={undefined}
      demoMode={undefined}
      signupURL={undefined}
      noIndex={undefined}
    />
    <main className="relative z-10">
      <SimpleHero
        icon={{
          src: '/static/images/icons/resources.svg',
          alt: 'Resources Logo'
        }}
        title="Resources"
        subtitle="Explore our resources, from open-source datasets, blog posts, to events and more."
        cta={{
          hubspotModal: {
            formId: 'cfa8ac7e-4222-4a49-ba1a-2d0728a8b002',
            label: 'Subscribe For Updates'
          }
        }}
      />

      <ResourcesList
        blogs={blogs}
        events={events}
        customers={customers}
        resources={resources}
        interviews={interviews}
        datasets={datasets}
        featuredResources={[
          <EventCard
            // className="min-h-[427px] md:min-h-[min-content]"
            content={events[0]}
            featured
          />,
          <BlogCard content={blogs[2]} featured />
        ]}
      />
    </main>
    <Footer border />
  </div>
);

Resources.defaultProps = {
  blogs: [],
  events: [],
  customers: [],
  resources: [],
  interviews: [],
  datasets: []
};

export default Resources;
